import Page from '../../components/layouts/page'
import RowMenu from '../../components/row_menu'
import { Trash } from '@phosphor-icons/react'
import { Button, EmptyState } from '@cinesend/ui-kit'
import DataTable from '../../components/data_table'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import useTableFilters from '../../hooks/use_table_filters'
import useStore from '../../hooks/use_store'
import { useState } from 'react'
import CreateOrgModal from './create_org_modal'

const Organizations = () => {
  const { data: organizations, error, isLoading, refetch } = useQuery(['organizations'])
  const { queryString, searching } = useTableFilters({
    enableSearch: true,
  })

  const [createOrgModal, setCreateOrgModal] = useState(false)

  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const { deleteModel } = useStore()

  const columns = [
    { key: 'name', header: 'Name', render: (data) => data.name },
    {
      key: 'actions',
      header: '',
      width: '50px',
      render: (data) => (
        <RowMenu
          label={`Actions for ${data.name}`}
          items={[
            {
              id: 'delete-organization',
              label: 'Delete Organization',
              tone: 'danger',
              icon: <Trash size={20} />,
              onSelect: () =>
                deleteModel.mutate({
                  endpoint: `organizations`,
                  id: data.id,
                  deleteNoun: 'organization',
                  deleteName: data.name,
                  onSuccess: () => queryClient.invalidateQueries(['organizations', queryString]),
                }),
            },
          ]}
        />
      ),
    },
  ]

  return (
    <Page
      title='Organizations'
      buttons={[
        <Button key={'create_org_button'} onClick={() => setCreateOrgModal(true)}>
          Create Organization
        </Button>,
      ]}
    >
      <DataTable
        caption='Organizations'
        columns={columns}
        rows={organizations ?? []}
        onRowClick={(data) => navigate(`/settings/organizations/${data.id}`)}
        isLoading={isLoading}
        error={error}
        onRetry={refetch}
        empty={<EmptyState title='No organizations found!' detail='Create an organization to begin.' />}
        searching={searching}
      />
      {createOrgModal && <CreateOrgModal onClose={() => setCreateOrgModal(false)} />}
    </Page>
  )
}

export default Organizations
